export enum PortalType {
    ClientPortal = 1,
    PartnerPortal = 2,
    BackOffice = 3,
    FrontOffice = 4
}
